import { kBlackOverlayImage } from '@euler/assets';
import { memo } from 'react';
import { Image, View } from 'react-native';

export const BlackOverlay = memo(() => {
  return (
    <View
      pointerEvents="none"
      css={`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      `}
    >
      <Image
        source={kBlackOverlayImage}
        resizeMode={'stretch'}
        css={`
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        `}
      />
    </View>
  );
});
